import { User } from "./user.model";

export function isUserDataFullfilled(user: User): boolean {
    return !!user.dateBorn
}